export const tableschema3 = {
    name_table: 'Розділ IІІ. Кількість працівників закладу на кінець звітного року(Державна статистика)',
    titles:[
        "Усього",
        "у тому числі педагогічний персонал",
        "з них директори",
        "вихователі",
        "вихователі-методисти",
        "практичні психологи",
        "соціальні педагоги",
        "асистенти вихователів в інклюзивних групах",
        "інструктори з фізкультури",
        "музичні керівники",
        "керівники гуртків",
        "інший педагогічний персонал",
        "з них корекційні педагоги у складі:",
        "логопеди",
        "тифлопедагоги",
        "дефектологи",
        "сурдопедагоги",
        "медичний персонал",
        "технічний персонал",
        "Із рядка 3100: – жінки",
        "- підвищили кваліфікацію з підтримки дітей з особливими освітніми потребами"
      ],
    parts:[
        {title: "Облікова кількість штатних працівників, осіб", subtitle: "усього", fields:[
            "PR3001",
            "PR3101",
            "PR3111",
            "PR3121",
            "PR3131",
            "PR3141",
            "PR3151",
            "PR31061",
            "PR31071",
            "PR31081",
            "PR31091",
            "PR3161",
            "PR31511",
            "PR31521",
            "PR31531",
            "PR31541",
            "PR31551",
            "PR3201",
            "PR3301",
            "",
            "PR3501"
          ]
        },{title: "Облікова кількість штатних працівників, осіб", subtitle: "жінки", fields:[
            "PR3002",
            "PR3102",
            "PR3112",
            "PR3122",
            "PR3132",
            "PR3142",
            "PR3152",
            "PR31062",
            "PR31072",
            "PR31082",
            "PR31092",
            "PR3162",
            "PR31512",
            "PR31522",
            "PR31532",
            "PR31542",
            "PR31552",
            "PR3202",
            "PR3302",
            "",
            "PR3502"
        ]},{title: "Облікова кількість штатних працівників, осіб", subtitle: "особи у віці до 35 років", fields:[
            "PR3003",
            "PR3103",
            "PR3113",
            "PR3123",
            "PR3133",
            "PR3143",
            "PR3153",
            "PR31063",
            "PR31073",
            "PR31083",
            "PR31093",
            "PR3163",
            "PR31513",
            "PR31523",
            "PR31533",
            "PR31543",
            "PR31553",
            "PR3203",
            "PR3303",
            "",
            "PR3503"
        ]},{title: "Облікова кількість штатних працівників, осіб", subtitle: "особи у віці 36-60 років", fields:[
            "PRAGE3000",
            "PRAGE3100",
            "PRAGE3101",
            "PRAGE3102",
            "PRAGE3103",
            "PRAGE3104",
            "PRAGE3105",
            "PRAGE3106",
            "PRAGE3107",
            "PRAGE3108",
            "PRAGE3109",
            "PRAGE3150",
            "PRAGE3151",
            "PRAGE3152",
            "PRAGE3153",
            "PRAGE3154",
            "PRAGE3155",
            "PRAGE3200",
            "PRAGE3300",
            "",
            "PRAGE3500"
        ]},{title: "Облікова кількість штатних працівників, осіб", subtitle: "особи у віці 61 років і старше", fields:[
            "PR3004",
            "PR3104",
            "PR3114",
            "PR3124",
            "PR3134",
            "PR3144",
            "PR3154",
            "PR31064",
            "PR31074",
            "PR31084",
            "PR31094",
            "PR3164",
            "PR31514",
            "PR31524",
            "PR31534",
            "PR31544",
            "PR31554",
            "PR3204",
            "PR3304",
            "",
            "PR3504"
        ]},{title: "Облікова кількість штатних працівників, осіб", subtitle: "особи, які мають освітній ступінь (освітньо-кваліфікаційний рівень) молодший бакалавр, молодший спеціаліст", fields:[
            "PR3005",
            "PR3105",
            "PR3115",
            "PR3125",
            "PR3135",
            "PR3145",
            "PR3155",
            "PR31065",
            "PR31075",
            "PR31085",
            "PR31095",
            "PR3165",
            "PR31515",
            "PR31525",
            "PR31535",
            "PR31545",
            "PR31555",
            "PR3205",
            "PR3305",
            "PR3405",
            "PR3505"
        ]},{title: "Облікова кількість штатних працівників, осіб", subtitle: "особи, які мають освітній ступінь (освітньо-кваліфікаційний рівень) бакалавр, спеціаліст, магістр", fields:[
            "PR3006",
            "PR3106",
            "PR3116",
            "PR3126",
            "PR3136",
            "PR3146",
            "PR3156",
            "PR31066",
            "PR31076",
            "PR31086",
            "PR31096",
            "PR3166",
            "PR31516",
            "PR31526",
            "PR31536",
            "PR31546",
            "PR31556",
            "PR3206",
            "PR3306",
            "PR3406",
            "PR3506"
        ]},{title: "посад, од", subtitle: "за штатним розписом", fields:[
            "PR3007",
            "PR3107",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "PR3207",
            "PR3307",
            "",
            ""
        ]},{title: "посад, од", subtitle: "фактично зайнятих", fields:[
            "PR3008",
        "PR3108",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "PR3208",
        "PR3308",
        "",
        ""
    ]}
    ],
    shorts:{
        titles:[
            "3000",
            "3100",
            "3101",
            "3102",
            "3103",
            "3104",
            "3105",
            "3106",
            "3107",
            "3108",
            "3109",
            "3150",
            "3151",
            "3152",
            "3153",
            "3154",
            "3155",
            "3200",
            "3300",
            "3400",
            "3500"
          ],
        parts:[
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9"
          ]
    }
};